import moment from 'moment';


// A helper function to extract database data into tables
// input: data:             database data, should be a json format
//        header:           the header of table
//        dataBaseHeader:   corresponding database header
// return: data for display tables
var groupBy = function(xs, key) {
	if (xs == null)
    { return null }
  	return xs.reduce(function(rv, x) {
    	(rv[x[key]] = rv[x[key]] || []).push(x);
    	return rv;
  }, {});
};

export { groupBy }


// WEBPACK FOOTER //
// ./src/components/SharedComponents/KRIDataGrouping.js